import useURLParam, { OverlayURLParam } from '../useURLParam/useURLParam';
import type { ThemeKey } from '../../themes/Theme';
import type { Theme } from '../../types/theme';

export default function useThemeTemplate(theme: Theme) {
  const debugOverride = useURLParam(OverlayURLParam.THEME_DEBUG) as ThemeKey;

  return debugOverride || theme.template;
}
